const FALLBACK_ROW_HEIGHT = 30;
const FALLBACK_HEADER_HEIGHT = 42;
const FALLBACK_PAGER_HEIGHT = 42;

const getGridMetrics = () => {
  const gridEl = document.getElementById("gridcomp");

  if (!gridEl) {
    return {
      gridEl: null,
      headerHeight: FALLBACK_HEADER_HEIGHT,
      pagerHeight: FALLBACK_PAGER_HEIGHT,
      rowHeight: FALLBACK_ROW_HEIGHT,
    };
  }

  const headerEl = gridEl.querySelector(".e-gridheader");
  const pagerEl = gridEl.querySelector(".e-gridpager");
  const firstRow = gridEl.querySelector(".e-row");

  return {
    gridEl,
    headerHeight: headerEl?.getBoundingClientRect().height ?? FALLBACK_HEADER_HEIGHT,
    pagerHeight: pagerEl?.getBoundingClientRect().height ?? FALLBACK_PAGER_HEIGHT,
    rowHeight: firstRow ? firstRow.getBoundingClientRect().height : FALLBACK_ROW_HEIGHT,
  };
};

export const calculateInitialPageSize = () => {
  const { gridEl, headerHeight, pagerHeight, rowHeight } = getGridMetrics();

  if (!gridEl) {
    return Math.floor((window.innerHeight * 0.65 - 20) / FALLBACK_ROW_HEIGHT) || 10;
  }

  const px = (el, prop) =>
    parseFloat(el ? getComputedStyle(el)[prop] : 0) || 0;

  const belowGrid =
    px(gridEl.closest(".grid-component"), "paddingBottom") +
    px(gridEl.closest(".accordion-body"), "paddingBottom") +
    px(gridEl.closest(".accordion-item"), "marginBottom") +
    px(gridEl.closest(".container-xxl"), "paddingBottom") +
    px(document.querySelector(".movyx-content"), "paddingBottom");

  const { top } = gridEl.getBoundingClientRect();
  const available = window.innerHeight - top - headerHeight - pagerHeight - belowGrid;

  return Math.max(1, Math.floor(available / rowHeight + 0.5));
};


export const calculateGridHeightFromPageSize = (pageSize) => {
  const { headerHeight, pagerHeight, rowHeight } = getGridMetrics();
  const size = Math.max(1, pageSize || 1);
  const height = headerHeight + pagerHeight + size * rowHeight;
  return `${Math.round(height)}px`;
};
